import teamCollaboration from "@/assets/team-collaboration.png";
import responsibleAI from "@/assets/responsible-ai.png";
const OurStory = () => {
  return <>
      {/* Section 1: Who We Are */}
      <section className="py-20 px-6 bg-background">
        <div className="container mx-auto max-w-6xl">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            {/* Content - LEFT */}
            <div className="space-y-6">
              <h2 className="text-4xl md:text-5xl font-bold text-foreground">
                Our Story
              </h2>
              
              <div className="space-y-4 text-muted-foreground text-lg leading-relaxed">
                <p>
                  AI-labbet is a network of senior experts in AI, digital transformation, ethics, and law. We work with executive teams and decision-makers to design and execute strategies that create business value through responsible AI.
                </p>
                
                <p>
                  As a network organization, we work without rigid hierarchies or silos. We form dynamic, cross-functional project teams that bring together the right expertise for each challenge, in a flexible and effective way. This structure allows us to adapt quickly to new trends and deliver tailored AI solutions that fit each client's goals and context.
                </p>
              </div>
            </div>
            
            {/* Image - RIGHT */}
            <div className="relative h-full">
              <img src={teamCollaboration} alt="Team collaborating in futuristic office with AI dashboards" className="w-full h-full object-cover rounded-lg" />
            </div>
          </div>
        </div>
      </section>

      {/* Section 2: Our Approach */}
      <section className="py-20 px-6 bg-background">
        <div className="container mx-auto max-w-6xl">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            {/* Image - LEFT (reversed order) */}
            <div className="relative order-2 md:order-1 h-full">
              <img src={responsibleAI} alt="Responsible use of AI - robot and human collaboration with scales of justice" className="w-full h-full object-cover rounded-lg" />
            </div>
            
            {/* Content - RIGHT */}
            <div className="space-y-6 order-1 md:order-2">
              <h2 className="text-4xl md:text-5xl font-bold text-foreground">
                Our Approach
              </h2>
              
              <div className="space-y-4 text-muted-foreground text-lg leading-relaxed">
                <p>
                  We are more than consultants, we are co-creators of your AI future. At AI-labbet, we believe innovation happens when vision and technology meet in true collaboration. That's why we work side by side with you, not as advisors on the sidelines, but as partners shaping the next chapter of your business. Our approach is deeply strategic: we start by understanding your ambitions, challenges, and opportunities. Together, we design AI solutions that reflect your values and accelerate your goals. We are independent, objective, and fearless in challenging assumptions or pushing the boundaries of what AI can achieve. For us, co-creation means building solutions that matter. Solutions that unlock new possibilities, drive transformation, and create lasting impact.
                </p>
                
                <p>
                  Our mission is to create positive impact through AI for both business and society. We are deeply committed to ensuring AI is used <span className="font-semibold">responsibly, transparently, and ethically</span>. By staying at the forefront of global AI developments and regulations, we help our clients stay compliant and ready for the future.
                </p>
                
                <p>
                  Whether you are just in the beginning of your AI journey or looking to scale your capabilities, we are here to help you unlock the full potential of AI, so if you’re ready to explore what’s possible and to push the boundaries of what's possible with AI, we’re ready to make it real.                        



 

    
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>;
};
export default OurStory;